import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../services/http/interceptors/GlobalInterciptor";
import vector from "./image1.png";
import vector1 from "./image.png";
import vector2 from "../../../images/Travelicons/vector left.png";
import timer from "./timerr.png";
import date from "./date.png";
import seat from "./seat.png";

const ListCamps = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const sliderRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get("/api/mobile/events");
        setPosts(response.data?.data?.data || []);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleNext = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({
        left: sliderRef.current.offsetWidth, // Scroll by one container width
        behavior: "smooth",
      });
    }
  };

  const handlePrev = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({
        left: -sliderRef.current.offsetWidth, // Scroll back by one container width
        behavior: "smooth",
      });
    }
  };

  if (loading) return <div className="text-center py-5">Loading...</div>;
  if (error) return <div className="text-center py-5 text-danger">Error: {error}</div>;

  return (
    <div className="container-fluid w-100">
      {/* Slider Section */}
      <div className="container mt-5">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 className="fw-bold" style={{ color: "rgba(20, 178, 189, 1)" ,fontSize:"25px" }}>Latest Camps by Champs</h2>
          <div className="d-flex justify-content-center align-items-center">
            <button
              className="btn btn-link text-decoration-none"
              onClick={() => navigate("/ListUmrah")}
            >
              <h4 className="me-1 fw-bold" style={{ color: "rgba(20, 178, 189, 1)",fontSize:"20px" }}>
                Explore More <img src={vector2} alt="" className="ms-2" style={{ width: "10px" }} />
              </h4>
            </button>
          </div>
        </div>

        <div className="position-relative">
          {/* Slider Container */}
          <div
            className="overflow-hidden mb-5 pb-5"
            ref={sliderRef}
            style={{
              overflowX: "scroll", // Enable horizontal scrolling
              scrollBehavior: "smooth", // Smooth scrolling
              whiteSpace: "nowrap", // Prevent wrapping of items
            }}
          >
            <div className="d-flex w-100">
              {posts.map((post) => (
                <div
                  className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4 px-2 d-inline-block"
                  key={post.id}
                  style={{ width: "320px" }} // Set a fixed width for each card
                >
                  <div
                    className="card border-0  shadow-sm h-100"
                    onClick={() => navigate(`/UmrahDetails/${post.id}`, { state: post.price })}
                    style={{ cursor: "pointer"  }}
                  >
                    <img
                      src={post.image || "https://via.placeholder.com/300x200"}
                      alt={post.title}
                      className=" rounded-4 mt-1 w-100 p-1 "
                      style={{ height: "95px", width:"280px", objectFit: "cover" }}
                    />
                    <div className="card-body" style={{ color: "rgba(47, 84, 102, 1)" }}>
                      <h5 className="card-title fs-5 fw-semibold pb-1">{post.title || "No Title"}</h5>
                      <p className="card-text fw-bold text-danger">${post.price || "N/A"}</p>
                      <div className="d-flex align-items-center">
                        <img src={timer} style={{ width: "20px" }} alt="" />
                        <span className="ms-3 mt-1">{post.period || 0} Days</span>
                      </div>
                      <div className="d-flex align-items-center mt-3">
                        <img src={date} style={{ width: "20px" }} alt="" />
                        <span className="ms-3"> Availability : {post.date_interval || "No Date"}</span>
                      </div>
                      <div className="d-flex align-items-center mt-3">
                        <img src={seat} style={{ width: "20px" }} alt="" />
                        <span className="ms-2">
                          Available Seats:{" "}
                          {post.remaining_seats > 0 ? (
                            <span style={{ color: "black" }}>{post.remaining_seats}</span>
                          ) : (
                            <span style={{ color: "rgba(237, 88, 89, 1)", fontWeight: "bold" }}>Fully Booked</span>
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Navigation Arrows */}
          <div className="position-absolute bottom-0 end-0 d-flex flex-wrap justify-content-center align-items-center pt-5 mt-5 d-md-flex d-none">
            <button
              className="btn btn-link text-decoration-none mx-5 circle-btn"
              onClick={handlePrev}
              style={{ fontSize: "20px" }}
            >
              <img src={vector1} alt="Previous" className="circle-icon" />
            </button>
            <button
              className="btn btn-link text-decoration-none circle-btn"
              onClick={handleNext}
              style={{ fontSize: "20px" }}
            >
              <img src={vector} alt="Next" className="circle-icon" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListCamps;